if($('.id--16').length){
    const storageKey = "productDepthData";
    let mapping_data = sessionStorage.getItem(storageKey);
    if (mapping_data) {
        mapping_data = JSON.parse(mapping_data);
        processDepthData(mapping_data);
    } else {
        $.getJSON("/user/documents/productDepth.json?v=" + new Date().getTime(), function(data) {
            if (data && data.length > 0) {
                sessionStorage.setItem(storageKey, JSON.stringify(data));
                processDepthData(data);
            } else {
                console.log("Soubor productDepth.json je prázdný nebo nebyl nalezen.");
            }
        }).fail(function() {
            console.log("Chyba při načítání productDepth.json");
        });
    }
    function processDepthData(mapping_data) {
        let depthMapping = {};
        $.each(mapping_data, function(index, item) {
            depthMapping[item.code] = parseFloat(item.depth);
        });
        $(".order-summary-inner .order-summary-item[data-micro='cartItem']").each(function() {
            let code_product = $(this).attr("data-micro-sku");
            if (depthMapping.hasOwnProperty(code_product)) {
                let depth = depthMapping[code_product];
                $(this).attr("data-depth", depth);

                depthConditions.forEach(({ condition, removeId }) => {
                    if (condition(depth)) {
                        let element = $('#order-shipping-methods .radio-wrapper#'+removeId).closest("div");
                        if (element.length > 0) {
                            element.remove();
                        }
                    }
                });
            }
        });
    }    
}